import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import ActionButton from "components/Buttons/ActionButton";
import SCRIPT_STATUS from "enums/SCRIPT_STATUS";
import useCreateOrUpdateScript from "hooks/api/useCreateOrUpdateScript";
import useVidletNavigate from "hooks/navigation/useVidletNavigate";
import { useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import useFormHelpers from "../FormScript/hooks/useFormHelpers";

export default function BtnPublish() {
  const { createOrUpdateScript, isWriting } = useCreateOrUpdateScript();
  const { payload } = useFormHelpers();
  const { navigate } = useVidletNavigate();
  const [openDialog, setOpenDialog] = useState(false);
  const { slug } = useParams();

  function onPublish() {
    const postScript = { ...payload };
    postScript.status = SCRIPT_STATUS.PUBLISHED;
    createOrUpdateScript(postScript).then(() => {
      navigate(`/project/${slug}/scripts`);
    });
  }

  const dialogPublish = useMemo(
    () => (
      <Dialog open={openDialog} maxWidth="sm" fullWidth>
        <DialogTitle>Publish this script? This cannot be undone</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            Once a script is published it cannot be changed. You will need to
            delete it and start over. If you are not sure this script is done,
            please cancel and save the script for additional edits.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <ActionButton onClick={() => setOpenDialog(false)}>
            Cancel
          </ActionButton>

          <ActionButton onClick={onPublish}>PUBLISH</ActionButton>
        </DialogActions>
      </Dialog>
    ),
    [isWriting, onPublish, openDialog],
  );

  return (
    <>
      <ActionButton onClick={() => setOpenDialog(true)} disabled={!payload.id}>
        PUBLISH
      </ActionButton>
      {dialogPublish}
    </>
  );
}
